/** ********  积分管理管理 ********* */
// 获取业务员积分信息列表
export const getSalesmanIntegralInfoList = {
  url: '/admin/salesman/integral/getSalesmanIntegralInfoList.json',
  method: 'get'
};

// 业务员积分兑换
export const integralExchange = {
  url: '/admin/salesman/integral/integralExchange.json',
  method: 'post'
};

// 业务员批量积分兑换
export const batchIntegralExchange = {
  url: '/admin/salesman/integral/batchIntegralExchange.json',
  method: 'post'
};

// 业务员获取积分列表
export const getIntegralExchangeList = {
  url: '/admin/salesman/integral/getIntegralExchangeList.json',
  method: 'get'
};

// 获取业务员积分支出列表
export const getIntegralIncomeList = {
  url: '/admin/salesman/integral/getIntegralIncomeList.json',
  method: 'get'
};

// 业务员积分 导出
export const exportSalesmanIntegralInfoList = {
  url: '/admin/salesman/integral/exportSalesmanIntegralInfoList.json'
};
